<template>
  <div
    class="scholar-search"
    :style="{minHeight: $route.name === 'technicalQA' ? 'calc(100vh - 80px)': '100vh'}"
  >
    <!-- 内容 -->
    <div class="content" style="flex: 1">
      <!-- 新建会话 -->
      <div class="infor" v-if="$route.name === 'technicalQA' || $route.name === 'technicalQAGuoJiao'">
        <div>
          <h1 class="title">
            <img src="@/assets/images/question/question_icon.png" height="64" width="110" />
            <img style="margin-left: 26px" src="@/assets/images/question/question_text.png" height="43" width="181" />
          </h1>
          <p class="tips">用于生成概念、方法、摘要等学术类内容</p>
          <div class="search-box" >
            <textareaComp ref="textAreaRef"/>
          </div>

          <!--  推荐问题  -->
          <div class="recommends-list">
            <p
              class="item"
              v-for="(item, index) in recommendData"
              :key="index"
              @click="handleClickRecommend(item)"
            >
              <questionIcon
                v-if="item.type === '2'"
                width="18"
                height="18"
                :fill="'#92b9ff'"
              />
              <span>{{ item.question }}</span>
            </p>
          </div>
        </div>
      </div>
      <!-- 技术问答历史会话 -->
      <div v-else class="history-list">
        <historyChat />
      </div>
    </div>
  </div>
</template>

<script>
import textareaComp from '@/views/scholarSearch/comps/textareaComp.vue';
import historyChat from '@/views/scholarSearch/comps/historyChat.vue';
import technicalQAIcon from '@/assets/images/home/btn2.svg';
import questionIcon from '@/assets/images/home/btn2.svg';

export default {
  name: 'scholarSearch',
  components: {
    technicalQAIcon,
    textareaComp,
    historyChat,
    questionIcon,
  },
  props: {},
  data() {
    return {
      recommendData: [
        {
          type: '2',
          typeText: '技术问答',
          question: '量子计算领域近五年的研究热点和前沿趋势有哪些？',
        },
        {
          type: '2',
          typeText: '技术问答',
          question: '光伏发电和风力发电在不同应用场景下的优劣势对比？',
        },
      ],
    };
  },
  created() {
    if(this.$route.name === 'technicalQAGuoJiao') {
      document.title = '技术问答';
    }
  },
  methods: {
    // 点击推荐的问题
    handleClickRecommend(item) {
      // console.log(item);
      this.$refs.textAreaRef.searchValue = item.question;
    },
  },
  watch: {}
};
</script>

<style scoped lang="less">
.scholar-search {
  background-image: url("~@/assets/images/question/question_bg.png");
  background-size: 100% 100%;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  display: flex;
  //min-height: calc(100vh - 70px);

  .search-box {
    margin: 0 auto;
    width: 80%;
    min-width: 580px;
    max-width: 1082px;
    padding-top: 41px;
  }

  .content {
    .infor {
      height: calc(100vh - 90px);
      min-height: 650px;
      //margin-top: 120px
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .title {
      height: 60px;
      font-size: 30px;
      color: #555;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        margin-left: 15px;
      }
    }

    p.tips {
      margin-top: 17px;
      font-weight: 500;
      color: #181F3E85;
      font-size: 16px;
      text-align: center;
    }
  }

  .history-list {
    /*height: calc(100vh - 280px) ;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 20px 20px 0;*/
  }
}

.recommends-list {
  width: 1100px;
  font-size: 14px;
  color: #666666;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 50px auto 0;
  padding-bottom: 20px;

  .item {
    cursor: pointer;
    display: flex;
    align-items: center;
    column-gap: 8px;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #ffffff;
    backdrop-filter: blur(12px);
    box-shadow: 0 2px 8px #6874ad40;
    background-color: #ffffff;
    margin: 15px 10px;

    &:hover {
      background-color: #f6f8fd;
    }
  }
}
</style>
